// Keep gaps in their original positions. Filtering before projecting points
// would move later measurements onto the wrong category or join across a gap.
export function chartPointSegments(data, project) {
  const segments = [];
  let segment = [];
  data.forEach((point, index) => {
    if (!Number.isFinite(point.y)) {
      if (segment.length) segments.push(segment);
      segment = [];
    } else segment.push(project(point, index));
  });
  if (segment.length) segments.push(segment);
  return segments;
}

export const chartLinePath = segments => segments.map(segment => segment
  .map((point, index) => `${index ? 'L' : 'M'} ${point.x} ${point.y}`).join(' ')).join(' ');

export const chartAreaPath = (segments, baseline) => segments.map(segment =>
  `${chartLinePath([segment])} L ${segment[segment.length - 1].x} ${baseline} L ${segment[0].x} ${baseline} Z`).join(' ');
